export default __webpack_public_path__ + "88ab4c17a18370223540b65267e094a6.svg";